
import { computed, defineComponent, onBeforeMount, reactive } from 'vue'

// components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import Loader from '@/common/components/UI/Loader/index.vue'
import TheTable from '@/common/components/UI/TheTable/index.vue'
import TableScrollWrapper from '@/common/components/UI/TableScrollWrapper/index.vue'

// types
import {
    DeliveryShipmentCost,
    DeliveryStandardParam,
} from '@/core/types/delivery-shipment-costs.types'

// realisations
import { deliveryShipmentCosts } from '@/core/realisations/delivery-shipment-costs.realisation'

// composable
import { useRoute } from 'vue-router'

// constants
import {
    IndividualTariffsMain,
    IndividualTariffs,
    StandardParamsColumns,
    StandardParamsRows,
    AdditionalServicesColumns,
} from '@/core/constants/columns/IndividualTariffs.columns'

import { INDIVIDUAL_PERCENT_LIST, INDIVIDUAL_PRICE_LIST } from '@/core/constants/billing.constants'
import { AdditionalServicesEnum } from '@/core/enums/billing.enums'

export default defineComponent({
    components: {
        'page-title': PageTitle,
        'the-button': TheButton,
        loader: Loader,
        TheTable,
        TableScrollWrapper,
    },
    setup() {
        const state = reactive({
            is_loading: false,
            is_failed: false,
            //
            tariff: null as DeliveryShipmentCost[] | null,
            tariff_second: null as DeliveryStandardParam[] | null,
            // tariff_third: null as AdditionalByIdT[] | null,
        })

        const route = useRoute()
        const company_id = Number(route.params.id)

        const loadIndividualTariff = async () => {
            try {
                state.is_loading = true
                state.is_failed = false

                const response = await deliveryShipmentCosts.getShipmentCosts({
                    page: 1,
                    limit: 9999,
                    companyId: company_id,
                })

                state.tariff = response.data

                const response_second = await deliveryShipmentCosts.getStandardParams({
                    page: 1,
                    limit: 9999,
                    companyId: company_id,
                })

                state.tariff_second = response_second.data

                // const response_third = await billing.getTariffThirdByCompanyId(company_id)
                // if (response_third) {
                //     state.tariff_third = response_third.data.filter(
                //         (t) => t.name !== 'manipulator' && t.name !== 'crane'
                //     )
                // }
            } catch (error) {
                console.log(error)
                state.is_failed = true
            } finally {
                state.is_loading = false
                state.is_failed = false
            }
        }

        const getIndexTitle = (key: string) => {
            let key_arr: string[] = key.split('-')

            let key_right = Number(key_arr[1])

            return key_right - 1
        }

        const getIndex = (key: string, rows_amount: number) => {
            let key_arr: string[] = key.split('-')

            let key_right = Number(key_arr[1])
            let key_left = Number(key_arr[0])

            return key_left + (key_right - 1) * rows_amount - 1
        }

        const getSign = (name: string) => {
            if (INDIVIDUAL_PERCENT_LIST.includes(name)) return '(%)'
            else if (INDIVIDUAL_PRICE_LIST.includes(name)) return '(₸)'
            else if (name === 'overloadWeight') return '(кг)'
            else return ''
        }

        const getParamsIndex = (key: string) => {
            let key_arr: string[] = key.split('-')

            let key_right = Number(key_arr[1])
            let key_left = Number(key_arr[0])

            let index = key_left + (key_right - 1) * 13

            return index < 13 ? index * 2 : index - (26 - index) + 1
        }

        const getCompanyName = computed(() => {
            return state.tariff && state.tariff[0] ? `(${state.tariff[0].companyName})` : ''
        })

        onBeforeMount(loadIndividualTariff)

        return {
            state,
            company_id,
            loadIndividualTariff,
            getIndexTitle,
            getIndex,
            getParamsIndex,
            getSign,
            //
            IndividualTariffsMain,
            IndividualTariffs,
            StandardParamsColumns,
            AdditionalServicesColumns,
            StandardParamsRows,
            AdditionalServicesEnum,
            //
            getCompanyName,
        }
    },
})
